import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

// ─── Eases ────────────────────────────────────────────────────────────────────

export const easeCustom = CustomEase.create('custom', '0.76, 0.05, 0.24, 1');

// ─── États initiaux (gsap.set) ────────────────────────────────────────────────

export const hiddenUp = (distance = 24) => ({ y: distance, opacity: 0 });

// ─── Vars d'animation (gsap.to) ───────────────────────────────────────────────

export const fadeInUp = { autoAlpha: 1, y: 0 };

export const fadeInUpStagger = { autoAlpha: 1, y: 0, stagger: { each: 0.1 } };
